// APIs
import type { AxiosInstance } from 'axios'
import type { PromoterIntegrationTaskApi } from '@audience-republic/audience-manager-shared/api/promoter-integration-task'
import PromoterIntegrationTask from '@audience-republic/audience-manager-shared/api/promoter-integration-task'
import TwilioSenderIds from './twilio-sender-ids'
import TwilioSmsCompanies from './twilio-sms-companies'
import Auth from './auth'
import Campaign from './campaigns'
import Brand from './brands'
import Event from './events'
import RsvpPage from './rsvp-pages'
import EventAnnotations from './event-annotations'
import PromoterAccounts from './promoter-accounts'
import PromoterProperty from './promoter-property'
import type { TagsApi } from './tags'
import Tags from './tags'
import MessageLists from './message-lists'
import CustomerProfile from './customer-profile'
import Automation from './automation'
import Integrations from './integrations'
import PromoterIntegrations from './promoter-integrations'
import Notifications from './notifications'
import Recipients from './recipients'
import Buckets from './buckets'
import Messages from './messages'
import MessageSenders from './message-senders'
import Csv from './csv'
import Activity from './activity'
import Beefree from './beefree'
import TicketClass from './ticket-classes'
import CustomFields from './custom-fields'
import ApiTokens from './api-tokens'
import TwilioSubAccounts from './twilio-sub-accounts'
import Oneschema from './oneschema'

export type ApiFactories = {
  tags: TagsApi
  promoterIntegrationTask: PromoterIntegrationTaskApi
  messageLists: ReturnType<typeof MessageLists>
  // TODO add other API factory types
} & Record<string, unknown>

export const createAPIs = (axios: AxiosInstance): ApiFactories => ({
  auth: Auth(axios),
  campaign: Campaign(axios),
  brand: Brand(axios),
  event: Event(axios),
  rsvpPage: RsvpPage(axios),
  eventAnnotations: EventAnnotations(axios),
  promoterAccounts: PromoterAccounts(axios),
  promoterProperty: PromoterProperty(axios),
  tags: Tags(axios),
  messageLists: MessageLists(axios),
  customerProfile: CustomerProfile(axios),
  automation: Automation(axios),
  integrations: Integrations(axios),
  promoterIntegrations: PromoterIntegrations(axios),
  // unlayer: Unlayer(axios),
  recipients: Recipients(axios),
  buckets: Buckets(axios),
  messages: Messages(axios),
  messageSenders: MessageSenders(axios),
  csv: Csv(axios),
  promoterIntegrationTask: PromoterIntegrationTask(axios),
  activity: Activity(axios),
  beefree: Beefree(axios),
  ticketClasses: TicketClass(axios),
  customFields: CustomFields(axios),
  apiTokens: ApiTokens(axios),
  twilioSubAccounts: TwilioSubAccounts(axios),
  twilioSenderIds: TwilioSenderIds(axios),
  twilioSmsCompanies: TwilioSmsCompanies(axios),
  oneschema: Oneschema(axios),
  notifications: Notifications(axios),
})
